module.exports = __webpack_public_path__ + "static/img/gpc_img.43b2ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activityforecast2024/gpc_img.png
// module id = kY+d
// module chunks = 0